import React from 'react';
import PropTypes from 'prop-types';
import { IconWrapper } from './Icon.styles';

export const Icon = ({
  svg: Svg,
  inline = false,
  scaled = false,
  size = 'small',
  ...rest
}) => {
  return (
    <IconWrapper scaled={scaled} inline={inline} size={size}>
      <Svg
        aria-hidden="true"
        focusable="false"
        role="img"
        version="1.1"
        viewBox="0 0 18 18"
        {...rest}
      />
    </IconWrapper>
  );
};

Icon.displayName = 'Icon';

Icon.propTypes = {
  /** docgen-ignore */
  svg: PropTypes.func.isRequired,
  /**
   * Set true to use icon inline
   */
  inline: PropTypes.bool,
  /**
   * Set scaled property to fit to any size. Icon will align to fixed parent`s size.
   */
  scaled: PropTypes.bool,
  /**
   * Icon size. Don't use in conjunction with inline and scaled.
   */
  size: PropTypes.oneOf(['small', 'regular', 'medium', 'large']),
};

export default Icon;
